import { toIsoDate } from "../../detail/twvFrist";

/**
 * DIE FRIST-PILLE der kompakten To-do-Zeile auf dem Handy (Artifact
 * „Vorgangsdetail mobil": „Heute fällig" rot, sonst „bis 30.10.").
 *
 * Die FRIST zählt vor der Wiedervorlage — sie ist die harte Grenze. Ohne
 * Frist steht die Wiedervorlage da („WV 30.10."), ohne beides nichts. Ein
 * erledigtes To-do zeigt keine Frist mehr: rot wäre dort falscher Alarm.
 *
 * `heute` ist injizierbar, damit der Test nicht am Kalender hängt.
 */
export type FristPilleTon = "rot" | "warn" | "still";
export type FristPille = { text: string; ton: FristPilleTon };

const tagMs = 86_400_000;

/** Lokales Kalenderdatum als Tageszahl — Sommerzeit verschiebt nichts. */
function tagesZahl(iso: string): number | null {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
    if (!m) return null;
    return Math.round(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3])) / tagMs);
}

function heuteZahl(heute: Date): number {
    return Math.round(Date.UTC(heute.getFullYear(), heute.getMonth(), heute.getDate()) / tagMs);
}

const kurz = (iso: string) => `${iso.slice(8, 10)}.${iso.slice(5, 7)}.`;

export function fristPille(
    a: { frist?: string | null; twv?: string | null; erledigt?: boolean },
    heute: Date = new Date(),
): FristPille | null {
    if (a.erledigt) return null;
    const jetzt = heuteZahl(heute);
    const frist = toIsoDate(a.frist);
    const fristTag = frist ? tagesZahl(frist) : null;
    if (frist && fristTag != null) {
        const d = fristTag - jetzt;
        if (d < 0) return { text: `überfällig seit ${kurz(frist)}`, ton: "rot" };
        if (d === 0) return { text: "Heute fällig", ton: "rot" };
        if (d === 1) return { text: "Morgen fällig", ton: "warn" };
        return { text: `bis ${kurz(frist)}`, ton: "still" };
    }
    const twv = toIsoDate(a.twv);
    const twvTag = twv ? tagesZahl(twv) : null;
    if (twv && twvTag != null) {
        const d = twvTag - jetzt;
        if (d <= 0) return { text: d === 0 ? "WV heute" : `WV seit ${kurz(twv)}`, ton: "warn" };
        return { text: `WV ${kurz(twv)}`, ton: "still" };
    }
    return null;
}
